import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import ConfirmDialog from "primevue/confirmdialog";
import { ref } from "vue";
import { useConfirm } from "primevue/useconfirm";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UConfirmDialog',
    props: {
        label: {
            type: String,
            required: true
        },
        acceptLabel: {
            type: String,
            default: "Save"
        },
        rejectLabel: {
            type: String,
            default: "Cancel"
        }
    },
    emits: ["accept", "reject"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const dialogId = ref(`dialog-${Math.random().toString(36).substr(2, 9)}`);
        const confirm = useConfirm();
        const emit = __emit;
        const openConfirmDialog = () => {
            confirm.require({
                group: dialogId.value,
                message: props.label,
                header: "Confirmation",
                icon: "pi pi-exclamation-triangle",
                rejectProps: {
                    label: props.rejectLabel,
                    severity: "secondary",
                    outlined: true
                },
                acceptProps: {
                    label: props.acceptLabel
                },
                accept: () => {
                    emit("accept");
                },
                reject: () => {
                    emit("reject");
                }
            });
        };
        __expose({
            openConfirmDialog
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ConfirmDialog), {
                group: dialogId.value,
                breakpoints: { '960px': '75vw', '640px': '90vw' },
                style: { width: '50vw' }
            }, null, 8, ["group"]));
        };
    }
});
